import Swiper from "swiper/bundle";
import accordion from "./components/accordion";
import activeAccordion from "./components/activeAccordion";

export default function fleetJs() {
	setTimeout(() => {
		document.querySelectorAll(".vesselsTitle").forEach((elem) => {
			let renderWidth = elem.offsetWidth;
			elem.style.width = `${renderWidth}px`;
		});
	}, 500);

	const accordionHeightSelector = document.querySelector(
		".VesselInfo .swiper-slide"
	);
	let accordHeight =
		window.innerWidth > 1023
			? accordionHeightSelector.scrollHeight - 50
			: undefined;
	document
		.querySelectorAll('.fleetContainer [data-js="accordion"]')
		.forEach((elem) => {
			accordion(elem, true, undefined, undefined);
			activeAccordion(elem);
		});

	var VesselsName = new Swiper(".VesselsName", {
		spaceBetween: 11,
		slidesPerView: "auto",
		freeMode: false,
		watchSlidesProgress: false,
	});

	setTimeout(() => {
		document
			.querySelectorAll(".VesselsName .swiper-slide")
			.forEach((elem, index) => {
				elem.addEventListener("click", function () {
					VesselsName.slideTo(index);
				});
			});
	}, 500);
	// VesselsName.on("activeIndexChange", function () {
	// 	VesselsName.slideTo(VesselsName.activeIndex);
	// });

	const VesselInfoSlider = document.querySelector(".VesselInfo");

	// swiper.slideTo(index, speed, runCallbacks)
	var VesselInfo = new Swiper(VesselInfoSlider, {
		autoHeight: false,
		slidesPerView: 1,
		spaceBetween: 10,
		// mousewheel: {
		// 	eventsTarget: ".fleetContainer",
		// 	forceToAxis: false,
		// 	sensitivity: 15,
		// 	releaseOnEdges: true,
		// },

		thumbs: {
			swiper: VesselsName,
		},
		navigation: {
			nextEl: ".VesselsName-next",
			prevEl: ".VesselsName-prev",
		},
		on: {
			afterInit: function () {
				let prevEl = document.querySelector(this.params.navigation.prevEl);
				this.isBeginning && (prevEl.style.opacity = 0.2);
			},
			slideChange: function () {
				let prevEl = document.querySelector(this.params.navigation.prevEl);
				let nextEl = document.querySelector(this.params.navigation.nextEl);
				if (this.isBeginning) {
					prevEl.style.opacity = 0.2;
					prevEl.disable;
				} else {
					prevEl.style.opacity = 1;
					prevEl.enable;
				}
				if (this.isEnd) {
					nextEl.style.opacity = 0.2;
					nextEl.disable;
				} else {
					nextEl.style.opacity = 1;
					nextEl.enable;
				}
			},
		},
	});

	// VesselsName.on("slideChange", function () {
	// 	VesselInfo.slideTo(this.activeIndex);
	// });
	// VesselInfo.on("slideChange", function () {
	// 	VesselsName.slideTo(this.activeIndex);
	// });
	// const vesselsNext = document.querySelector(".VesselsName-next");
	// const vesselsPrev = document.querySelector(".VesselsName-prev");

	// vesselsNext.addEventListener("click", () => {
	// 	VesselInfo.slideNext();
	// 	// vesselsNext.slideNext();
	// });
	// vesselsPrev.addEventListener("click", () => {
	// 	VesselInfo.slidePrev();
	// 	// vesselsNext.slidePrev();
	// });

	let isDragging = false;
	const body = document.querySelector("body");
	const newElement = document.createElement("div");
	newElement.innerHTML =
		'<div class=" relative flex gap-x-6 col-[1_/_-2] justify-self-end lg:justify-self-start lg:col-[3_/_span_1] translate-y-full lg:translate-y-0 z-10"><div class="VesselsName-prev flex items-center justify-center w-[calc(25_/_16_*_1rem)] aspect-square rounded-full invert lg:invert-0" tabindex="0" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-5e8eeb15d8d1fc25" aria-disabled="false" style="opacity: 1;"><img class=" -scale-75 lg:-scale-100 relative" src="../../images/arrow-right.svg" alt="prev slide"></div><div class="VesselsName-next flex items-center justify-center w-[calc(25_/_16_*_1rem)] aspect-square rounded-full invert lg:invert-0" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-5e8eeb15d8d1fc25" aria-disabled="false" style="opacity: 1;"><img class="scale-75 lg:scale-100" src="../../images/arrow-right.svg" alt="next slide"></div></div>';
	newElement.classList.add("mouseFollow");
	newElement.style =
		"display: none;position: fixed;z-index: 100;pointer-events: none;transform: translate(-50%, -50%);";
	body.append(newElement);

	function detectMousePosition(event) {
		// Get the mouse position from the event object
		const mouseX = event.clientX;
		const mouseY = event.clientY;

		// Check if the mouse button is pressed and set the dragging flag accordingly
		if (event.type === "mousedown") {
			isDragging = true;
		} else if (event.type === "mouseup") {
			isDragging = false;
		}

		// Check if the mouse is dragging or just moving without dragging
		if (isDragging) {
			newElement.style.left = `${mouseX}px`;
			newElement.style.top = `${mouseY}px`;
		} else {
			newElement.style.left = `${mouseX}px`;
			newElement.style.top = `${mouseY}px`;
		}
	}

	VesselInfoSlider.querySelectorAll(".swiper-slide .background-image").forEach(
		(elem) => {
			elem.addEventListener("mouseenter", () => {
				newElement.style.display = "block";
				VesselInfoSlider.addEventListener("mousedown", detectMousePosition);
				VesselInfoSlider.addEventListener("mousemove", detectMousePosition);
				VesselInfoSlider.addEventListener("mouseup", detectMousePosition);
			});
		}
	);
	VesselInfoSlider.querySelectorAll(".swiper-slide .background-image").forEach(
		(elem) => {
			elem.addEventListener("mouseleave", () => {
				newElement.style.display = "none";
				VesselInfoSlider.removeEventListener("mousedown", detectMousePosition);
				VesselInfoSlider.removeEventListener("mousemove", detectMousePosition);
				VesselInfoSlider.removeEventListener("mouseup", detectMousePosition);
			});
		}
	);
}
